export default __webpack_public_path__ + "static/media/u-turn.5877dbdc.png";